import type { PropsWithChildren } from "react";

import { Keyboard } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import FullScreenImageBackground from "@/ui/components/onboarding/FullScreenImageBackground";
import { ScreenContainer, ScrollView, VStack } from "@/ui/layout";
import { LayoutToken } from "@/ui/theme/tokens";
import { isAndroid } from "@/utils/platform.util";

const handleBackgroundPress = () => {
  if (Keyboard.isVisible()) {
    Keyboard.dismiss();
  }
};

const LoginScreenContainer = ({
  children,
  testID,
}: PropsWithChildren<ViewWithTestID>) => {
  // this screen ignores safe area (full-bleed background), so on Android lift the bottom
  // content (footer links + version label) clear of the system nav bar
  const { bottom: bottomInset } = useSafeAreaInsets();
  const bottomPadding =
    LayoutToken.OnboardingScreenHorizontalPadding +
    (isAndroid() ? bottomInset : 0);

  return (
    <ScreenContainer shouldIgnoreSafeArea>
      <FullScreenImageBackground testID={testID}>
        <ScrollView
          bounces={false}
          contentContainerStyle={{ flex: 1 }}
          keyboardShouldPersistTaps="handled"
        >
          <VStack
            flex={1}
            gap={24}
            minHeight="100%"
            onPress={handleBackgroundPress}
            padding={LayoutToken.OnboardingScreenHorizontalPadding}
            paddingBottom={bottomPadding}
          >
            {children}
          </VStack>
        </ScrollView>
      </FullScreenImageBackground>
    </ScreenContainer>
  );
};

export default LoginScreenContainer;
